import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_COMPLETENESS_NAMESPACE = `${PARTNER360_NAMESPACE}/completeness`

// Async thunk constants
export const REQUEST_RECALCULATE_COMPLETENESS = `${PARTNER360_COMPLETENESS_NAMESPACE}/recalculateCompleteness`
